import { useQuery } from '@apollo/react-hooks';
import { useMemo } from 'react';
import { GET_COMPANY_QUERY } from '../../queries/GET_COMPANY_QUERY';


export function useFeatureQuery( options ) {
    const { data: rawData, loading, error, refetch } = useQuery( GET_COMPANY_QUERY, {
        ...options,
    } );

    return useMemo ( () => {
        return {
            error,
            loading,
            data: rawData,
            refetch,
        };
    }, [ rawData, error, loading, refetch ] );
}
